module.exports = __webpack_public_path__ + "static/img/save.330a684c.png";